// extracted by mini-css-extract-plugin
export default {"cls1":"rregy06ZFiRA6YEQMmY2","cls2":"_sDPciyQVdRdYAOvvdcL rregy06ZFiRA6YEQMmY2"};